<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import DataSection from '../components/data/DataSection.vue';
import { Entry } from '@/components/data/';
import { useStudyStore } from '@/stores/study';
import { useRoute, useRouter } from 'vue-router';
import { routeConstants } from '@/utils';

const router = useRouter();
const studyStore = useStudyStore();
const route = useRoute();

const isEntryRoute = computed(() => {
  return route.matched.some(record => record.path.startsWith('/dash/data/') && record.path.includes('/form/'));
});

onMounted(() => {
  redirect();
});

watch(() => router.currentRoute.value, () => {
  redirect();
});

const redirect = () => {
  if (router.currentRoute.value.path === '/dash/data') {
    if (studyStore.selectedStudy?.longitudinal) {
      router.replace({ name: routeConstants.CASES.name, query: router.currentRoute.value.query });
    } else {
      router.replace({ name: routeConstants.ENTRIES.name });
    }
  }
};
</script>

<template>
    <div class="data-container" v-if="studyStore.selectedStudy">
        <Entry v-if="isEntryRoute"/>
        <DataSection v-else/>
    </div>
</template>

<style scoped lang="scss">
.data-container {
  display: flex;
  height: 100%;
  overflow: hidden;
}
</style>
